import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductMockup } from './ProductMockup';
import { CHECKOUT_URL } from '../data/checkout';
const included = ['6 volumes · 40 weeks of classes', '5 instant-use bonuses', '300 landscape pages, print or phone', '30, 45 and 60-minute class versions', '21 planning worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-198" data-mp="1rsq36im6p0mt">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-199" data-mp="25shl2uftn163">
        <div className="text-center" data-id="element-200" data-mp="20t4p9k6z2jrd">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-coral-deep" data-id="element-201" data-mp="20s3dfdi4tt8l">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-202" data-mp="3h9hdrr62zi0n">
            Everything you need to teach the{' '}
            <span className="text-coral-deep" data-id="element-203" data-mp="3vz7323obgzsn">whole season</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-204" data-mp="4rkubwmqq74x">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-205" data-mp="9t0b3chvxrhi">
            <h3 className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-206" data-mp="erlgdqbzv1ct">
              Dance Class Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-207" data-mp="3d6urqrfoqo6d">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-208" data-mp="3n6vbufldp8bm">
            <div className="mx-auto max-w-lg" data-id="element-209" data-mp="3n5tzm7smmfsb">
              <ProductMockup data-id="element-210" data-mp="3rydd74rbdax4" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-211" data-mp="3rz6c5jk16w4p">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-212" data-mp="2ui7ngb5c22tu">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-sage/20" data-id="element-213" data-mp="2zg9epjcwx8ge">
                    <CheckIcon className="h-3 w-3 text-plum" aria-hidden="true" data-id="element-214" data-mp="2reryxyyzyiu8" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-215" data-mp="2w7bfn4szdu39">
              <p className="text-[13px] text-ink-soft" data-id="element-216" data-mp="28hqssatpicop">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-217" data-mp="23ixh8nxzcvr6">$90 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-plum" data-id="element-218" data-mp="2ig6m8kg7hy1d">
                <span className="mt-2.5 font-display text-3xl font-bold" data-id="element-219" data-mp="2ie3mh8p94qjg">$</span>
                <span className="font-display font-bold text-6xl leading-[0.9] sm:text-7xl" data-id="element-220" data-mp="2dfio7etk8gxn">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-221" data-mp="3ow8vz2dmtgtd">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-222" data-mp="9m1gdyu7m93">
                <span className="rounded-full border border-gold bg-gold px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-gold-ink" data-id="element-223" data-mp="5a0055ejtjug">
                  Save $63
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-224" data-mp="3rfwupnxlvipv">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-225" data-mp="o07zdcf4nq5d">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-226" data-mp="e8lpbjeizx47">
                Get Dance Class Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-227" data-mp="16qfv39ghzebj">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-228" data-mp="3f8jw0decgl6a">
                <li className="flex items-center gap-1.5" data-id="element-229" data-mp="3a7nq5uafmoy8">
                  <LockIcon className="h-4 w-4 text-coral-deep" aria-hidden="true" data-id="element-230" data-mp="358t0q9hym255" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-231" data-mp="319bu3cqsqyye">
                  <ZapIcon className="h-4 w-4 text-coral-deep" aria-hidden="true" data-id="element-232" data-mp="1t5frlx0qxbg" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-233" data-mp="3szglhvcz4m94">
                  <ShieldCheckIcon className="h-4 w-4 text-coral-deep" aria-hidden="true" data-id="element-234" data-mp="3o7os7d2fo2fa" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-235" data-mp="kjdc9l67qpio">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}